import { proxy } from "jquery";
import React,{Component} from "react";
import Header from "../components/Header";
import firebase  from '../db/Config_firebase';



class Login_page extends React.Component{

  constructor() {
    super();
    this.state = {
        mobile: '',
    };
  }

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  }

  onSubmit = (e) => {
    e.preventDefault();
    //console.log(this.state);
    var mogileNo = +919700860399;
   let recaptcha = new firebase.auth.RecaptchaVerifier('recaptcha');
   let phoneNumber = '+919700860399';
   firebase.auth().signInWithPhoneNumber(phoneNumber, recaptcha)
        .then(function(e){
            let code = prompt('Enter OTP','');
            if(code == null)return;
            e.confirm(code).then(function(result){
                console.log(result.user,'user');
                document.querySelector('label').textContent = result.user.phoneNumber +" Number Verified";
            }).catch((error)=>{
                console.log(error);
            })
        })


//    const phoneNumber = mogileNo;
//    const appVerifier = true;
//    Fbase.auth().signInWithPhoneNumber(phoneNumber, appVerifier)
//    .then((confirmationResult) => {
//      // SMS sent. Prompt user to type the code from the message, then sign the
//      // user in with confirmationResult.confirm(code).
//      console.log("success");
//      // ...
//    }).catch((error) => {
//      // Error; SMS not sent
//      // ...
//    });
  }


 

    render(){
      const {mobile} = this.state;
        return(
            <div>

                {/*<!-- Header Container -->*/}
				<Header />
                {/*<!-- Header Container / End -->*/}

                {/*<!-- Titlebar -->*/}
                  <div className="parallax titlebar" style={{backgroundImage:"url(assets/images/home-parallax-3.jpg)", backgroundAttachment:"fixed", backgroundSize:"1838px 1176.32px", backgroundPosition:"50% -222.269px"}}>
                    <div class="parallax-overlay" style={{backgroundColor:"rgb(54, 56, 62)", opacity: "0.7"}}></div>
                    <div id="titlebar">
                      <div className="container">
                        <div className="row">
                          <div className="col-md-12">
                            <h2>Log In</h2>
                            {/*<!-- Breadcrumbs -->*/}
                            <nav id="breadcrumbs">
                              <ul>
                                <li><a href="index.html">Home</a></li>
                                <li>Log In</li>
                              </ul>
                            </nav>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  {/*<!-- Contact -->*/} 
                  <div className="container">
                    <div className="row">
                      <div className="col-md-6 col-md-offset-3">
                        <div className="my-account">
                          <div className="tabs-container"> 
                            {/*<!-- Login -->*/}
                			  <div className="utf-welcome-text-item">
                				<h3>Welcome Back Sign in to Continue</h3>
                				<span>Don't Have an Account? <a href="register.html">Sign Up!</a></span> 
                			  </div>

                              <label></label>
                              <div id="recaptcha"></div>

                              <form className="login" onSubmit={this.onSubmit}>
                                <div id="recapthadiv"></div>  
                                <div className="form-row form-row-wide">
                                    <input type="text" className="input-text" name="mobile" id="mobile" placeholder="Enter Mobile Number" value={mobile} onChange={this.onChange} required />
                                </div>
                                
                				<input type="submit" className="button full-width border margin-top-10" name="login" value="Login With Phone" />
                					
                              </form>

                              <div className="utf-social-login-separator-item"><span>or</span></div>

                              <form method="post" className="login">
                                <div className="form-row form-row-wide">
                                    <input type="text" className="input-text" name="email" id="email" placeholder="Email Address" value="" />
                                </div>
                                <div className="form-row form-row-wide">
                                    <input className="input-text" type="password" name="password" placeholder="Password" id="password"/>
                                </div>
                                <div className="form-row">
                                  <div className="checkbox margin-top-10 margin-bottom-10">
                					<input type="checkbox" id="two-step"/>
                					<label for="two-step"><span className="checkbox-icon"></span> Remember Me</label>
                				  </div>
                				  <a className="lost_password" href="forgot_password.html">Forgot Password?</a>	
                                </div>
                				<input type="submit" className="button full-width border margin-top-10" name="login" value="Login" />
                				<div className="utf-social-login-separator-item"><span>or</span></div>
                				<div className="utf-social-login-buttons-block">
                					<button className="button social-login via-twitter"><i className="icon-brand-facebook-f"></i> Facebook</button>
                					<button className="button social-login via-gplus"><i className="icon-brand-google-plus-g"></i> Google+</button>
                					<button className="button social-login via-facebook"><i className="icon-brand-twitter"></i> Twitter</button>
                				</div>	
                              </form>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div id="recaptcha-container"></div>
                  </div>
                  {/*<!-- Container / End -->*/} 

            </div>
        )
    }
}


export default Login_page;